import { STATS } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative scroll-mt-28 border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">Who we are</p>
        <p className="mt-8 max-w-4xl font-display text-2xl font-bold leading-snug tracking-tight sm:text-4xl lg:text-5xl">
          Desires After Hours is a{" "}
          <span className="text-zinc-500">private networking creative agency</span>{" "}
          dedicated to facilitating connections and fostering personal growth.
          As a multifaceted creative agency, we provide personalized services
          tailored to meet the diverse needs of our clients.
        </p>
      </Reveal>

      <div className="mt-20 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 lg:grid-cols-4" data-testid="stats-grid">
        {STATS.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 0.08} className="bg-[#050505]">
            <div className="p-8">
              <p className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
                {stat.value}
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.2em] text-zinc-500">{stat.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
